/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type RestoreTaskInput = {|
  taskEventCount?: ?string,
  ignoreParent?: ?boolean,
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type RestoreTaskMutationVariables = {|
  input: RestoreTaskInput
|};
export type RestoreTaskMutationResponse = {|
  +restoreTask: ?{|
    +restoredTaskEventCount: ?string
  |}
|};
export type RestoreTaskMutation = {|
  variables: RestoreTaskMutationVariables,
  response: RestoreTaskMutationResponse,
|};
*/


/*
mutation RestoreTaskMutation(
  $input: RestoreTaskInput!
) {
  restoreTask(input: $input) {
    restoredTaskEventCount
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "RestoreTaskInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RestoreTaskPayload",
    "kind": "LinkedField",
    "name": "restoreTask",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "restoredTaskEventCount",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RestoreTaskMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RestoreTaskMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "RestoreTaskMutation",
    "operationKind": "mutation",
    "text": "mutation RestoreTaskMutation(\n  $input: RestoreTaskInput!\n) {\n  restoreTask(input: $input) {\n    restoredTaskEventCount\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '780cb46e74944a2569c073dcfd2227d9';

module.exports = node;
